/** Realistic placeholder copy — matches Shopify checkout editor previews. */
export const DUMMY_CUSTOMER = Object.freeze({
  firstName: "Darlene",
  lastName: "Sauer",
  email: "darlene.sauer@example.com",
  address1: "Netaji Subhash Marg",
  address2: "Lal Qila, Chandni Chowk",
  city: "New Delhi",
  state: "DL",
  zip: "110006",
  country: "India",
});

export const DUMMY_CART_ITEM = Object.freeze({
  title: "The Collection Snowboard: Liquid",
  price: "₹749.95",
});

export const DUMMY_ORDER_TOTALS = Object.freeze({
  subtotal: "₹749.95",
  shipping: "₹10.00",
  taxes: "₹134.99",
  total: "INR ₹894.94",
});

export const SURFACE_WIDGET_BADGES = Object.freeze({
  CHECKOUT: "Checkout-Extension widget",
  THANK_YOU_PAGE: "Thank you - Extension widget",
  ORDER_STATUS_PAGE: "Order status - Extension widget",
  CART_DRAWER: "Cart drawer widget",
});

export const DUMMY_CART_DRAWER_LINE_ITEM = Object.freeze({
  title: "Selling Plans Ski Wax",
  price: "$24.95",
  quantity: 1,
  imageUrl: "",
});

export const DUMMY_CART_DRAWER_TOTAL = Object.freeze("$24.95 USD");

export function formatCustomerAddress(customer = DUMMY_CUSTOMER) {
  return [
    `${customer.firstName} ${customer.lastName}`,
    customer.address1,
    customer.address2,
    `${customer.zip} ${customer.city} ${customer.state}, ${customer.country}`,
  ].join("\n");
}
